import { createContext, useContext, useState, type ReactNode } from 'react'

interface SearchDrawerContextType {
	isOpen: boolean
	setIsOpen: (open: boolean) => void
}

const SearchDrawerContext = createContext<SearchDrawerContextType | undefined>(
	undefined,
)

export function SearchDrawerProvider({ children }: { children: ReactNode }) {
	const [isOpen, setIsOpen] = useState(false)

	return (
		<SearchDrawerContext.Provider value={{ isOpen, setIsOpen }}>
			{children}
		</SearchDrawerContext.Provider>
	)
}

export function useSearchDrawer() {
	const context = useContext(SearchDrawerContext)
	if (context === undefined) {
		throw new Error(
			'useSearchDrawer must be used within a SearchDrawerProvider',
		)
	}
	return context
}
